import {
    mapState,
    mapActions
} from 'vuex'
// import { Dialog } from 'vant'
export default {
    name: 'officialAccountsDialog',
    props: {
        overlaystatus: {
            type: Number,
            default: 1
        },
        // 小程序门店id
        storeId: {
            type: String | Number,
            default: ''
        },
        // php门店id
        phpSstoreId: {
            type: String | Number,
            default: ''
        },
        // 小程序门店首页二维码
        qrCode: {
            type: String,
            default: ''
        },
        // 优惠券跳转小程序（适用商品页面）所需参数
        coupon: {
            type: Object,
            default: () => {
                return {
                    wechat_sstore_id: '', // 小程序门店id
                    user_receive_coupon_id: '', // 用户领取优惠券记录id
                    coupon_id: '', // 优惠券id
                    sstore_id: '', // php门店id
                    coupon_type: '1', // 优惠券类型 bc优惠券1 bd优惠券2
                    is_details: '1', // H5（服务详情、营销活动详情）进入传1，其他传0或不穿
                }
            }
        },
        // 跳转类型 (home: 小程序首页[默认],mall: 小程序商城页,couponGoodsList: 适用服务优惠券列表)
        type:{
            type: String,
            default: ''
        }
    },
    data () {
        return {
            showStatus: false,
            // message: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIyMTk0NzcyNw==&scene=110#wechat_redirect'
            message: '枫车养车',
            text: '枫车养车'
        }
    },
    created () {},
    activated () {},
    mounted () {},
    methods: {
        ...mapActions(['getCarNoBelongTo']),
        onCopy (e) {
            this.$toast('复制成功')
        },
        open () {
            this.showStatus = true
        },
        close () {
            this.showStatus = false
        },
        toDownload () {
            this.$router.push('/appDownload')
        },
        // toOfficialAccounts () {
        //     location.href = this.message
        // }

        copy (e) {
            console.log(e)
        },
        onSuccess () {
            this.$toast('复制成功')
            this.close()
        },
        onError () {
            this.$toast('复制失败')
            this.close()
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin
        }),
        show () {
            return this.isWeixin
        },
        /**
         * 公共组件
         * 跳转小程序页面路径及参数，需更具不同的页面逻辑进行不同的跳转
         * 1.服务优惠券跳转-->枫车养车小程序-适用商品列表页-->package/coupon/pages/couponGoodsList/couponGoodsList.html
         * @params {coupon}
         * 2.门店主页(进入门店商城) -->枫车养车小程序-商城页-->/pages/mall/mall.html
         * @params {php_storeId，wechatStoreid}
         * 3.其他 -->枫车养车小程序-首页. 如果有php门店id的时候跳转对应的小程序门店首页，否则直接不带门店id跳转小程序门店首页-->/pages/home/home.html
         * @params {storeId}
         */
        wechatPage () {
            const jumpType = this.type
            let url = ''
            if (jumpType === 'mall') {
                const storeId = this.phpSstoreId
                // php_storeId --> PHP 门店id
                url = `/pages/mall/mall.html?isShare=1&php_storeId=${storeId}`
            } else if (jumpType === 'couponGoodsList') {
                const {
                    user_receive_coupon_id,
                    coupon_id,
                    coupon_type,
                    sstore_id,
                    wechat_sstore_id,
                    is_details
                } = this.coupon
                // wechat_sstore_id --> 小程序门店id,  sstore_id--> PHP 门店id
                url = `package/coupon/pages/couponGoodsList/couponGoodsList.html?wechat_sstore_id=${wechat_sstore_id}&user_receive_coupon_id=${user_receive_coupon_id}&coupon_id=${coupon_id}&coupon_type=${coupon_type}&sstore_id=${sstore_id}&is_details=${is_details}`
            } else {
                const storeId = this.phpSstoreId ? this.phpSstoreId : ''
                // storeId --> PHP 门店id
                url = `/pages/home/home.html?isShare=1&storeId=${storeId}`
            }
            return url
        }
    }
    // components: { Dialog }
}
